// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const almaLanguages = {     
   EN: 'en',
   NL: 'nl',
   FR: 'fr',
   DE: 'de',
   IT: 'it',
   KO: 'ko',
   NB: 'nb',
   NO: 'no',
   ES: 'es',
   SV: 'sv',
   CY: 'cy',
   ZH: 'zy',
   ZA: 'zh',
   SE: 'se',
   NN: 'nn',
   HE: 'he',
   PL: 'pl',
   CA: 'ca',
   PT: 'pt',
   DA: 'da',
   JP: 'ja',
   AR: 'ar'
}
//LANGUAGES NOT CURRENTLY SUPPORTED BY MAVERICK
// EU: 'EU'
// GA: 'GA'
angular.module('summonApp.constants')
   .constant('$almaLanguages', almaLanguages)
